/**
 * @deprecated
 */
export enum ClvFormStringStatus {
  INVALID_FORM = 'invalid_form',
  VALID_FORM = 'valid_form',
  ERROR_200 = 'error_200',
  INVALID_LOGIN_OR_PASSWORD = 'invalid_login_password',
  UNKNOW_ERROR = 'unkown_error',
}
